import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-star-rating',
  templateUrl: './star-rating.component.html',
  styleUrls: ['./star-rating.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class StarRatingComponent implements OnInit {

  @Input()
  selectedPoint = -1;

  @Input()
  starCount = 5;

  hoverStarIndex = -1;
  starList;

  @Input()
  isEditable = true;

  @Output()
  onStarSelected = new EventEmitter<any>();
  constructor() { }

  ngOnInit() {
    this.starList = new Array(this.starCount);
  // console.log("star", this.selectedPoint);
  }

  setSelectedStar(star) {
    this.selectedPoint = star;
    this.onStarSelected.emit(star); 
  // console.log("star", this.selectedPoint);

  }
}



// WEBPACK FOOTER //
// /var/www/bizisystem-frontend/src/src/app/shared/star-rating/star-rating.component.ts